import { createFileRoute } from '@tanstack/react-router';
import { LoyaltyEditPage } from './LoyaltyEditPage';

export const Route = createFileRoute('/_protected/admin/loyalty/$loyaltyId/edit/')({
  component: LoyaltyEditPage,
});
